import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import CircleIcon from '@mui/icons-material/Circle';
import { prioritiesNames, PRIORITY } from '../../constants/filters';

const priorityColors = {
  [PRIORITY.LOW]: 'success.main',
  [PRIORITY.MEDIUM]: 'info.main',
  [PRIORITY.HIGH]: 'warning.main',
  [PRIORITY.CRITICAL]: 'error.main',
};

function StatusCell({ priority }) {
  if (!priority) return null;

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <CircleIcon sx={{ fontSize: 12, color: priorityColors[priority] }} />
      <Typography variant="body2">{prioritiesNames[priority]}</Typography>
    </Box>
  );
}

StatusCell.propTypes = {
  priority: PropTypes.oneOf(Object.values(PRIORITY)).isRequired,
};

export default StatusCell;
